import '.c0{position:relative;}.ssr-plugin'
import '.bc{margin-bottom:2rem;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.dz{bottom:-2rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { ReactNode } from 'react'
import defaultBanner from '@app/assets/defaultBanner.png'
import { ImageWithFallback } from '../image/ImageWithFallback'
import useMediaQuery from '@app/util/useMediaQuery'
import { FileSelector } from '../input/text/FileSelector'
import { faUpload } from '@fortawesome/pro-regular-svg-icons'

export type BannerProps = {
  image?: string
  editMode?: boolean
  bannerStyle?: Style
  children?: ReactNode
  onNewBannerSeleted?: (file: File) => void
}

export const Banner = ({
  image,
  editMode = false,
  bannerStyle,
  children,
  onNewBannerSeleted,
}: BannerProps) => {
  const isMobile = useMediaQuery()
  const renderEditMode = editMode && !!onNewBannerSeleted
  return (
    <div className="c0 bc">
      <ImageWithFallback
        src={image}
        fallback={defaultBanner}
        style={{
          display: 'block',
          height: isMobile ? '8rem' : '18rem',
          width: '100%',
          minHeight: isMobile ? '8rem' : '12rem',
          objectFit: 'cover',
          borderRadius: isMobile ? '0.9375rem' : '1.875rem',
          filter: editMode ? 'opacity(50%)' : 'none',
          ...bannerStyle,
        }}
      />
      <div className="l dz"
        style={{
          left: isMobile ? '1rem' : '2rem',
        }}
      >
        {children}
      </div>
      {renderEditMode && (
        <FileSelector
          icon={faUpload}
          iconStyle={{
            fontSize: '2rem',
          }}
          containerStyle={{
            position: 'absolute',
            bottom: '1rem',
            right: '1rem',
            cursor: 'pointer',
          }}
          onFileSelectionUpdated={(files) => onNewBannerSeleted(files[0])}
        />
      )}
    </div>
  )
}
